/**
 * Auto-generated from dark-roast/api-envoy OpenAPI spec. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum CandidateStatus {
  Completed = "Completed",
  Cooled = "Cooled",
  Engaged = "Engaged",
  FalseStart = "FalseStart",
  Interested = "Interested",
  InterestedRejected = "InterestedRejected",
  Interviewing = "Interviewing",
  Rejected = "Rejected",
  Removed = "Removed",
  RepBioShare = "RepBioShare",
  Selected = "Selected",
  ShortList = "ShortList",
  Submitted = "Submitted",
  Suggested = "Suggested",
  TalentOptOut = "TalentOptOut",
  Warmed = "Warmed",
  WarmedUnsure = "WarmedUnsure",
  WarmedYes = "WarmedYes",
}

export const CandidateStatusDisplay: Record<CandidateStatus, string> = {
  [CandidateStatus.Completed]: "Completed",
  [CandidateStatus.Cooled]: "Cooled",
  [CandidateStatus.Engaged]: "Engaged",
  [CandidateStatus.FalseStart]: "False Start",
  [CandidateStatus.Interested]: "Interested",
  [CandidateStatus.InterestedRejected]: "Interested Rejected",
  [CandidateStatus.Interviewing]: "Interviewing",
  [CandidateStatus.Rejected]: "Rejected",
  [CandidateStatus.Removed]: "Removed",
  [CandidateStatus.RepBioShare]: "Rep Bio Share",
  [CandidateStatus.Selected]: "Selected",
  [CandidateStatus.ShortList]: "Short List",
  [CandidateStatus.Submitted]: "Submitted",
  [CandidateStatus.Suggested]: "Suggested",
  [CandidateStatus.TalentOptOut]: "Talent Opt Out",
  [CandidateStatus.Warmed]: "Warmed",
  [CandidateStatus.WarmedUnsure]: "Warmed Unsure",
  [CandidateStatus.WarmedYes]: "Warmed Yes",
};
